/**
 * Milqit runs on Indian Standard Time: "today" and "tomorrow" (delivery mornings) are IST calendar
 * days. Delivery dates are stored as midnight UTC of that IST day, e.g. "2026-11-15T00:00:00.000Z".
 */
export const BUSINESS_TIME_ZONE = "Asia/Kolkata";

const DAY_MS = 86_400_000;
const formatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: BUSINESS_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/** "YYYY-MM-DD" of the IST calendar day that contains `date`. */
export function businessDayKey(date: Date): string {
  return formatter.format(date);
}

/** The stored form of a business day: midnight UTC of that calendar date. */
export function businessDayStart(dayKey: string): Date {
  return new Date(`${dayKey}T00:00:00.000Z`);
}

/** The moment an IST calendar day begins (India keeps +05:30 all year), for filtering timestamps. */
export function businessDayOpensAt(dayKey: string): Date {
  return new Date(`${dayKey}T00:00:00.000+05:30`);
}

export function addDays(dayKey: string, days: number): string {
  return new Date(businessDayStart(dayKey).getTime() + days * DAY_MS).toISOString().slice(0, 10);
}

const clockFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: BUSINESS_TIME_ZONE,
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

/** "HH:mm" (24h) of `date` on the IST clock. */
export function businessTime(date: Date): string {
  return clockFormatter.format(date);
}

/**
 * The earliest morning an order placed at `now` can be delivered: tomorrow until the day's order
 * cut-off ("22:00", IST), the day after from then on — tomorrow's crates are already being packed.
 */
export function firstDeliveryDay(now: Date, orderCutoff: string): string {
  return addDays(businessDayKey(now), businessTime(now) < orderCutoff ? 1 : 2);
}
